export default class GlyphTranslations {
    static instances = new Map();
    tabs = new Map();

    constructor(translationsId, tabsSource) {
/*        if (GlyphTranslations.instances.has(translationsId)) {
            return GlyphTranslations.instances.get(translationsId);
        }*/
        this.translationsId = translationsId;
        this.skeleton = this.createPlaceholderTemplate();

        for (var i in tabsSource) {
            this.#addTab(tabsSource[i]);
        }

        this.#initTabs();
        GlyphTranslations.instances.set(this.translationsId, this);
    }

    #addTab(jsTab) {
        /**
         *
         * @type {number}
         * 0 - not loaded; 1 - in progress; 2 - loaded
         */
        jsTab.loadStatus = 0;
        this.tabs.set(jsTab.id, jsTab);
    }

    #initTabs() {
        let activeTab = $(this.translationsId + " div.tab-pane.active");
        activeTab.html(this.skeleton);
        const triggerTabList = document.querySelectorAll(this.translationsId + ' .nav-tabs button');

        this.#makeTabRequest('#' + activeTab.attr('id'))

        triggerTabList.forEach(triggerEl => {
            const tabTrigger = bootstrap.Tab.getOrCreateInstance(triggerEl)

            triggerEl.addEventListener('click', event => {
                event.preventDefault()
                let targetTab = triggerEl.getAttribute('data-bs-target');

                this.#makeTabRequest(targetTab)
                tabTrigger.show();
            })
        })
    }

    #makeTabRequest(targetTab) {
        let targetTabData = this.tabs.get(targetTab);
        let currentLangInput = $(this.translationsId + ' input[name="current_lang"]');
        currentLangInput.val(targetTabData.requestData.token.lang_uid)
        if (targetTabData.loadStatus == 0) {
            $(targetTab).html(this.skeleton)
            targetTabData.loadStatus = 1;

            $.ajax({
                method: 'POST',
                url: APPLICATION + '/service/allgroups/get_translations',
                data: targetTabData.requestData,
                dataType: 'json',
            }).done(function (response) {
                if (response.code == 200) {
                    targetTabData.loadStatus = 2;
                    $(targetTab).html(response.data.html);
                    initializeToolbarSubmitButton();
                    if ($(targetTab).find("textarea[maxlength]").length > 0 || $(targetTab).find("input[maxlength]").length > 0) {
                        maxlengthInit();
                    }
                } else {
                    showAlert(ALERT_TYPE, response);
                }
            }).fail(function (error) {
                showAlert(ALERT_TYPE, {code: 400, message: error.responseText});
            })
        }
    }

    createPlaceholderTemplate() {
        const template = `
        <div class="ph-item">
            <div class="ph-col-12">
                <div class="ph-row">
                    <div class="ph-col-12 big"></div>
                    <div class="ph-col-4"></div>
                    <div class="ph-col-8 empty"></div>
                    <div class="ph-col-6"></div>
                    <div class="ph-col-6 empty"></div>
                    <div class="ph-col-12"></div>
                </div>
            </div>

            <div class="ph-col-12">
                <div class="ph-picture"></div>
                <div class="ph-row">
                    <div class="ph-col-10 big"></div>
                    <div class="ph-col-2 empty big"></div>
                    <div class="ph-col-4"></div>
                    <div class="ph-col-8 empty"></div>
                    <div class="ph-col-6"></div>
                    <div class="ph-col-6 empty"></div>
                    <div class="ph-col-12"></div>
                </div>
            </div>
            <div class="ph-col-2">
                <div class="ph-picture"></div>
            </div>
            <div>
                <div class="ph-row">
                    <div class="ph-col-4"></div>
                    <div class="ph-col-8 empty"></div>
                    <div class="ph-col-6"></div>
                    <div class="ph-col-6 empty"></div>
                    <div class="ph-col-2"></div>
                    <div class="ph-col-10 empty"></div>
                </div>
            </div>
        </div>
    `;

        return template;
    }
}

